import React, { PropsWithChildren } from "react";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

export const FileDownloadPlainText = withShowIf((props: PropsWithChildren<any>) => (
  <span onClick={props.onClick}>{props.children}</span>
));
